// extracted by mini-css-extract-plugin
export default {"formContainer":"EditAccountant_formContainer__uCaEX","formField":"EditAccountant_formField__OlbEf","btnsContainer":"EditAccountant_btnsContainer__1NXTN"};